import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { useCurrentUser } from '@neo.tax/shared/hooks';

/*
  This hook identifies a user to launch darkly.
*/
export const useLaunchDarklyIdentify = (): void => {
  const ldClient = useLDClient();
  const { user } = useCurrentUser();

  // We identify the launch darkly user here so that we can add company information
  // alongside the user information
  useEffect(() => {
    // We identify the launch darkly user here so that we can add company information
    // alongside the user information.  Identify does a merge update when the user
    // already exists
    if (ldClient && user) {
      ldClient.identify({
        kind: 'user',
        key: user.id,
        email: user.email,
        name: user.fullName,
      });
    }
  }, [user, ldClient]);
};
